var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c("JadeGroupHeader", [_vm._v(_vm._s(_vm.$t("title")))]),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("acquirer"), trailing: _vm.data.acquirer },
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("acquirer-message") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _vm.data.message
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2 max-w-60" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: {
                              color: "medium",
                              variant: "text-medium",
                              weight: "medium",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.data.message) + " ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: {
          label: _vm.$t("acquirer-return-code"),
          trailing: _vm.data.returnCode,
        },
      }),
      _c("JadeDivider"),
      _vm.data.operationType
        ? _c("JadeListItem", {
            attrs: {
              label: _vm.$t("operation-type"),
              trailing: _vm.data.operationType,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "trailing",
                  fn: function () {
                    return [
                      _c(
                        "JadeTag",
                        { attrs: { size: "medium", variant: "neutral" } },
                        [_vm._v(" " + _vm._s(_vm.data.operationType) + " ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1206106254
            ),
          })
        : _vm._e(),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("tid"), tooltip: _vm.$t("tid-description") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _vm.data.tid
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: {
                              color: "medium",
                              variant: "text-medium",
                              weight: "medium",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.data.tid) + " ")]
                        ),
                        _c("jade-icon-button", {
                          attrs: { size: "small", icon: "action-copy" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(_vm.data.tid)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _c("span", [_vm._v(" - ")]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("nsu"), tooltip: _vm.$t("nsu-description") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _vm.data.nsu
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: {
                              color: "medium",
                              variant: "text-medium",
                              weight: "medium",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.data.nsu) + " ")]
                        ),
                        _c("jade-icon-button", {
                          attrs: { size: "small", icon: "action-copy" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(_vm.data.nsu)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _c("span", [_vm._v(" - ")]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("auth-code") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _vm.data.autorizationCode
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c(
                          "jade-text",
                          {
                            attrs: {
                              color: "medium",
                              variant: "text-medium",
                              weight: "medium",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.data.autorizationCode) + " "
                            ),
                          ]
                        ),
                        _c("jade-icon-button", {
                          attrs: { size: "small", icon: "action-copy" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(_vm.data.autorizationCode)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _c("span", [_vm._v(" - ")]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("pgid") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2 max-w-56" },
                  [
                    _c(
                      "jade-text",
                      {
                        attrs: {
                          color: "medium",
                          variant: "text-medium",
                          weight: "medium",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.data.pgid) + " ")]
                    ),
                    _c("jade-icon-button", {
                      attrs: { size: "small", icon: "action-copy" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopy(_vm.data.pgid)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
      _c("JadeListItem", {
        attrs: { label: _vm.$t("orderKey") },
        scopedSlots: _vm._u([
          {
            key: "trailing",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2 max-w-56" },
                  [
                    _c(
                      "jade-text",
                      {
                        attrs: {
                          color: "medium",
                          variant: "text-medium",
                          weight: "medium",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.data.orderKey) + " ")]
                    ),
                    _c("jade-icon-button", {
                      attrs: { size: "small", icon: "action-copy" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCopy(_vm.data.orderKey)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("JadeDivider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }